export default __webpack_public_path__ + "static/media/appointment-booking-undraw.45116b8d.png";